import 'bootstrap/dist/css/bootstrap.min.css';
import Head from 'next/head';
import type { Metadata } from "next";
import { Geist, Geist_Mono } from "next/font/google";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./globals.css";
import "./../assets/css/style.css";
import "./../assets/css/all-fontawesome.min.css";
import "./../assets/css/animate.min.css";
import { Toaster } from "react-hot-toast";
import { getSetting } from '@/action/getSetting';
import urls from '@/utils/urls/urls';
import FaviconDynamic from '@/components/Favicon/FaviconDynamic';
const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"],
});

const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"],
});

export async function generateMetadata() {

  // fetch data
  const setting = await fetch(urls?.setting).then((res) => res.json())

  return {
    title: 'TEX EXCELLENCE LIMITED',
    description: 'TEX EXCELLENCE LIMITED, a leading textile solutions provider, is committed to delivering high-quality textile products and innovative solutions that meet the diverse needs of our global clientele. With decades of experience in the textile industry, we specialize in a wide range of products including fabrics, garments, and accessories. Our state-of-the-art manufacturing facilities and dedicated team of experts ensure that every product we deliver upholds the highest standards of quality and craftsmanship. At TEX EXCELLENCE LIMITED, we are passionate about sustainability and are continually seeking ways to reduce our environmental footprint through eco-friendly practices and sustainable sourcing. Our customer-centric approach drives us to build long-lasting relationships with our clients, offering personalized services and tailored solutions to meet their specific requirements. Whether you are a small business or a large corporation, TEX EXCELLENCE LIMITED is your trusted partner in the textile industry, delivering excellence and innovation every step of the way.',
    icons: {
      icon: urls?.root + setting?.fav_image,
      shortcut: urls?.root + setting?.fav_image,
      apple: urls?.root + setting?.fav_image,
    },
  }
}

// export const metadata: Metadata = {
//   title: 'TEX EXCELLENCE LIMITED',
//   description: 'TEX EXCELLENCE LIMITED, a leading textile solutions provider, is committed to delivering high-quality textile products and innovative solutions that meet the diverse needs of our global clientele. With decades of experience in the textile industry, we specialize in a wide range of products including fabrics, garments, and accessories. Our state-of-the-art manufacturing facilities and dedicated team of experts ensure that every product we deliver upholds the highest standards of quality and craftsmanship. At TEX EXCELLENCE LIMITED, we are passionate about sustainability and are continually seeking ways to reduce our environmental footprint through eco-friendly practices and sustainable sourcing. Our customer-centric approach drives us to build long-lasting relationships with our clients, offering personalized services and tailored solutions to meet their specific requirements. Whether you are a small business or a large corporation, TEX EXCELLENCE LIMITED is your trusted partner in the textile industry, delivering excellence and innovation every step of the way.',
// };

// const settings = getSetting()

// console.log("settings", settings)

export default async function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {

  // const settings = await getSetting();
  // console.log("settings", settings)
  return (
    <html lang="en" data-theme="light">
      
      <body className={`${geistSans.variable} ${geistMono.variable}`}>
        <Toaster
          position="top-center"
          reverseOrder={false}
        />
        <FaviconDynamic />
        {children}
      </body>
    </html>
  );
}
